if (!window.lsPlpFiltersInitialized) {
  window.lsPlpFiltersInitialized = true;
  const mobileFilters = window.matchMedia('(max-width: 767px)');
  function setupDrawers() {
    document.querySelectorAll('.plp-filters:not(.plp-filters--drawer-ready)').forEach((filters) => {
      const drawer = filters.querySelector('.plp-filters__drawer');
      if (!drawer || typeof drawer.showModal !== 'function') return;
      const groups = filters.querySelector('.plp-filters__groups');
      const trigger = filters.querySelector('.plp-filters__mobile-trigger');
      const marker = document.createComment('Filter groups position');
      groups.before(marker);
      const sort = filters.querySelector('.plp-filters__sort');
      const sortMarker = document.createComment('Sort position');
      sort.before(sortMarker);
      filters.classList.add('plp-filters--drawer-ready');
      trigger.addEventListener('click', () => {
        if (!mobileFilters.matches) return;
        drawer.querySelector('.plp-filters__drawer-content').append(groups);
        drawer.querySelector('.plp-filters__drawer-sort').append(sort);
        groups.querySelectorAll('details').forEach((group) => { group.open = true; });
        drawer.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('plp-filter-modal-open');
      });
      drawer.querySelector('.plp-filters__drawer-close').addEventListener('click', () => drawer.close());
      drawer.addEventListener('click', (event) => {
        if (event.target !== drawer) return;
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
      });
      drawer.addEventListener('close', () => {
        marker.after(groups);
        sortMarker.after(sort);
        groups.querySelectorAll('details').forEach((group) => { group.open = false; });
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('plp-filter-modal-open');
        if (mobileFilters.matches) trigger.focus();
      });
    });
  }
  setupDrawers();
  document.addEventListener('shopify:section:load', setupDrawers);
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('.plp-filters__drawer[open]')) document.documentElement.classList.remove('plp-filter-modal-open');
  });
  mobileFilters.addEventListener('change', () => {
    if (!mobileFilters.matches) document.querySelectorAll('.plp-filters__drawer[open]').forEach((drawer) => drawer.close());
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('.plp-filters__sort select')) {
      event.target.parentElement.querySelector('.plp-filters__sort-size').textContent = event.target.selectedOptions[0].text;
      if (!event.target.closest('.plp-filters__drawer')) event.target.form.requestSubmit();
    }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.plp-filters__group[open]').forEach((group) => {
      if (group.closest('.plp-filters__drawer')) return;
      if (!group.contains(event.target)) group.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (event.target.closest('.plp-filters__drawer')) return;
    const group = event.target.closest('.plp-filters__group[open]');
    if (group) {
      group.open = false;
      group.querySelector('summary').focus();
    }
  });
}
